import { EDisplay } from 'components/deal-results/product-items';
import { EDealComparisonAction, IDealWithEvaluation, IDealComparisonState } from 'store/deal-comparison/types';
import { EForecastEvaluationType } from 'store/deal-evaluation/types';

interface IDealComparisonActionEvaluateDealsSuccess {
  type: typeof EDealComparisonAction.EVALUATE_DEALS_SUCCESS;
  dealsWithEvaluation: IDealWithEvaluation[];
}

interface IDealComparisonActionAddDeal {
  type: typeof EDealComparisonAction.ADD_DEAL;
  dealWithEvaluation: IDealWithEvaluation;
}

interface IDealComparisonActionAddDealsFromDashboard {
  type: typeof EDealComparisonAction.ADD_DEALS_FROM_DASHBOARD;
  dealsWithEvaluation: IDealWithEvaluation[];
}

interface IDealComparisonActionRemoveDeal {
  type: typeof EDealComparisonAction.REMOVE_DEAL;
  index: number;
}

interface IDealComparisonActionRemoveAllDeals {
  type: typeof EDealComparisonAction.REMOVE_ALL_DEALS;
  dealsWithEvaluation: IDealWithEvaluation[];
}

interface IDealComparisonActionUpdateDealOrder {
  type: typeof EDealComparisonAction.UPDATE_DEAL_ORDER;
  dealsWithEvaluation: IDealWithEvaluation[];
  compareDealIds: string[];
}

interface IDealComparisonActionUpdateForecastType {
  type: typeof EDealComparisonAction.UPDATE_FORECAST_TYPE;
  forecastType: EForecastEvaluationType;
}

interface IDealComparisonActionUpdateSelectedDisplay {
  type: typeof EDealComparisonAction.UPDATE_SELECTED_DISPLAY;
  selectedDisplay: EDisplay;
}

interface IDealComparisonActionCompareDealIds {
  type: typeof EDealComparisonAction.SET_COMPARE_DEAL_IDS;
  compareDealIds: string[];
}

type TDealComparisonAction =
  | IDealComparisonActionEvaluateDealsSuccess
  | IDealComparisonActionUpdateForecastType
  | IDealComparisonActionRemoveDeal
  | IDealComparisonActionRemoveAllDeals
  | IDealComparisonActionAddDeal
  | IDealComparisonActionAddDealsFromDashboard
  | IDealComparisonActionUpdateDealOrder
  | IDealComparisonActionUpdateSelectedDisplay
  | IDealComparisonActionCompareDealIds;

export const initialState: IDealComparisonState = {
  compareDealIds: [],
  dealsWithEvaluation: [],
  forecastType: EForecastEvaluationType.IHS,
  selectedDisplay: EDisplay.NETBACK,
};

export default (state = initialState, action: TDealComparisonAction) => {
  switch (action.type) {
    case EDealComparisonAction.SET_COMPARE_DEAL_IDS: {
      return {
        ...state,
        compareDealIds: action.compareDealIds,
      };
    }
    case EDealComparisonAction.ADD_DEAL: {
      return {
        ...state,
        dealsWithEvaluation: [...state.dealsWithEvaluation, action.dealWithEvaluation],
      };
    }

    case EDealComparisonAction.ADD_DEALS_FROM_DASHBOARD:
    case EDealComparisonAction.EVALUATE_DEALS_SUCCESS: {
      return {
        ...state,
        dealsWithEvaluation: action.dealsWithEvaluation,
      };
    }

    case EDealComparisonAction.UPDATE_FORECAST_TYPE: {
      return {
        ...state,
        forecastType: action.forecastType,
      };
    }

    case EDealComparisonAction.REMOVE_DEAL: {
      return {
        ...state,
        dealsWithEvaluation: state.dealsWithEvaluation.filter((_d, index) => action.index !== index),
      };
    }

    case EDealComparisonAction.REMOVE_ALL_DEALS: {
      return {
        ...state,
        dealsWithEvaluation: [],
      };
    }

    case EDealComparisonAction.UPDATE_DEAL_ORDER: {
      return {
        ...state,
        dealsWithEvaluation: action.dealsWithEvaluation,
        compareDealIds: action.compareDealIds,
      };
    }

    case EDealComparisonAction.UPDATE_SELECTED_DISPLAY: {
      return {
        ...state,
        selectedDisplay: action.selectedDisplay,
      };
    }
    default: {
      return state;
    }
  }
};
